/*
 * @Author: genwai
 * @Date: 2020-04-21 16:59:32
 * @LastEditTime: 2020-04-26 10:09:40
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \onesports-cloud-view-new\src\views\activiti\ModelList\modelClass.js
 */
import pageClass from '@/unit/pageClass'

class searchFrom extends pageClass {
  constructor(type) {
    super()
    if (type === 'form') {
      this.taskName = ''
      this.delFlag = false
    }
  }
}

export default searchFrom
